import React from 'react'
import { useState, useEffect } from "react";
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import Icon from "../Icon/Icon";
import SendRequest from "../../request/SendRequest";

const PassBill = ({
    billingData,
    loading,
    setLoading,
    snackBar,
    setSnackBar,
}) => {
    const [accordionExpanded, setAccordionExpanded] = useState(billingData.map(() => false));
    const handleAccordionChange = (key) => {
        const newAccordionExpanded = [...accordionExpanded];
        newAccordionExpanded[key] = !accordionExpanded[key];
        setAccordionExpanded(newAccordionExpanded);
    };
    const [data, setData] = useState()

    useEffect(() => {
        if (data?.isPdfValid && data?.pdfContent) {
            // create a blob URL for the PDF data
            const blob = new Blob([new Uint8Array(atob(data?.pdfContent).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            // Automatically trigger a download for the PDF file
            const link = document.createElement('a');
            link.href = url;
            link.download = `${data.fileName || 'document'}`; // Use the filename from params or a default name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return () => URL.revokeObjectURL(url);
        }
    }, [data]);

    const getStatementContent = async (type, filename) => {
        setLoading(true)
        try {
            const response = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/billingStatements/' + type + '/' + filename });
            if (response.status === 200) {
                setData(response.data.data);
            }
        } catch (error) {
            console.log(error);
            setSnackBar({
                open: true,
                message: "發生錯誤，請稍後再試",
                severity: "error",
            })
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Box width={"100%"} maxWidth={"360px"} margin={"0 auto"} display={"flex"} flexDirection={"column"} gap={"16px"} padding={"20px 0"}>
                {
                    billingData.map((data, key) => {
                        return (
                            <Accordion
                                key={key}
                                sx={{ "&:before": { display: "none" }, boxShadow: "none", ".MuiAccordionDetails-root": { padding: 0 } }}
                                expanded={accordionExpanded[key]}
                                onChange={() => handleAccordionChange(key)}
                            >
                                <AccordionSummary
                                    expandIcon={<Icon name={accordionExpanded[key] ? "minus" : "plus"} />}
                                    aria-controls={"statement-group-content-" + key}
                                    id={"statement-group-id-" + key}
                                    sx={{ borderBottom: "1px solid #EAEAEA", padding: "0" }}

                                >
                                    <Typography fontSize={16} fontWeight={700} color={"#43474E"} component="span">{data.statementGroupLabel}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: "16px 0" }}>
                                    {
                                        data.statements.map((data, key) => {
                                            return (
                                                <Box
                                                    key={key}
                                                    display={"flex"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}
                                                    padding={"16px 0px"}
                                                    borderBottom={"1px solid #EAEAEA"}
                                                    onClick={() => getStatementContent(data.type,data.filename )}
                                                    sx={{ cursor: "pointer" }}
                                                >
                                                    <Typography fontSize={16} fontWeight={500} color={"#43474E"} component="span">{data.fileNameLabel}</Typography>
                                                    <Icon name="next" />
                                                </Box>
                                            )
                                        })
                                    }
                                </AccordionDetails>
                            </Accordion>
                        )
                    })

                }
            </Box>
        </>
    )
}

export default PassBill